import { object, string } from 'yup';

export const selectionItemSchema = object().shape({
  value: string().trim().required(),
  label: string().trim().required(),
});
